<template id="mmt-field-wet-report-screen">
  <section>
    <div class="row">
      <div class="col-md-10 col-lg-12 text-center mt-3 mb-5">
        <div class="card">
         <div class="card-header">
          <div class="d-flex flex-wrap mb-3">
           <div class=" p-2 float-left"><b>Field Wet Report</b>
             <div>
              <span class="mr-auto p-1" >
                 <button id="button" style="margin-left: -30px" :class=" x['test_file_name'] ? 'ml-1 btn-sm btn-warning':'ml-1 btn-sm disabled'" :disabled="x['test_file_name'] ? false:true " @click="loadReportConfig(x)"> Submit </button>
              </span>
              <span class="mr-auto p-1" >
                 <button class=" btn-sm btn-outline-danger" @click="reset()"> Reset </button>
              </span>
              </div>
             </div>
             <span v-for="(key,l) of screenletListboxDim" :key="l">
                <div class=" p-2">{{SLlistboxDimBizName[l]}}:
                    <v-select v-model="x[key]" @input="toggleButton()" :options="getValues(key,x)">
                    </v-select>
                </div>
             </span>
             <div class="mt-3 p-2" v-on:click="generatePDF(x)">
                    <i class="far fa-file-pdf fa-2x"></i>
             </div>
             </div>
           </div>
          <div class="card-body"  v-if="showtable">
            <div class="table-responsive" id="content">
              <div>
                <table class="table table-hover table-bordered" width="100%">
                  <thead>
                  <tr class="text-center">
                  <th colspan="6"  style="word-spacing: 15px" class="title">COMPARATIVE  FIELD  PERFORMANCE  REPORT</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                  <th class="text-left">Test Request No</th>
                  <td class="text-center">{{this.headerdata[0].test_request_no}}</td>
                  <th>Tractor Sr.NO</th>
                  <td>{{this.headerdata[0].tractor_sr_no}}</td>
                  <th colspan="2"  class="text-left color2">Objective :</th>
                  </tr>
                  <tr>
                  <th class="text-left">Test Report No.</th>
                  <td class="text-center color1">
                  {{this.headerdata[0].test_report_no}}
                  </td>
                  <th>Test Date</th>
                  <td>{{this.headerdata[0].date_of_test}}</td>
                  <td colspan="2"  class="text-left  color2">{{this.headerdata[0].objective_of_test}}</td>
                  </tr>
                  <tr>
                  <th class="text-left">Tractor Model </th>
                  <td class="text-center">{{this.headerdata[0].tractor_model}}</td>
                  <th>Generation</th>
                  <td>{{this.headerdata[0].generation}}</td>
                  <th colspan="2"  class="text-left  color2">Background Of Test :</th>
                  </tr>
                  <tr>
                  <th class="text-left">Objective Tractor</th>
                  <td class="text-center">{{this.headerdata[0].objective_tractor}}</td>
                  <th>Competition Tractor</th>
                  <table width="100%">
                  <tr v-for="(wtc,index) in comptrac" v-bind:key="index" >
                  <td height="20%" >{{wtc.tractor_model}} </td>
                  </tr>
                  </table>
                  <td colspan="2" class="text-left  color2">{{this.headerdata[0].background_of_test}}</td>
                  </tr>
                  <tr>
                  <th class="text-left">Test Report Date</th>
                  <td class="text-center">{{this.headerdata[0].test_report_date}}</td>
                  <th>Platform</th>
                  <td>{{this.headerdata[0].platform}}</td>
                  <th width="10%" class="color2">Test Standard Referred: </th>
                  <th colspan="2" width="10%" class="color2">108 P/29</th>
                  </tr>
                  <tr>
                  <th class="text-left">Test Location</th>
                  <td class="text-center">{{this.headerdata[0].test_location_name}}</td>
                  <th>Project/Group</th>
                  <td>{{this.headerdata[0].project_group}}</td>
                  <td rowspan="3" colspan="2" class="color2">{{this.headerdata[0].test_standard_ref}}</td>
                  </tr>
                  <tr>
                  <th class="text-left">Implement Details</th>
                  <td colspan="3">{{this.headerdata[0].name_of_implement}}</td>
                  </tr>
                  <tr>
                  <th class="text-left">Field Condition</th>
                  <td colspan="3" >{{this.headerdata[0].field_condition}}</td>
                  </tr>
                  <template v-if="iteration1wetTrac.length > 0">
                  <tr>
                  <th class="text-left color3">Test Condition</th>
                  <th  class="text-center" colspan="6">{{iteration1wetTrac[0].test_condition}}</th>
                  </tr>
                  <tr >
                  <th class="text-left">Tractor Model</th>
                  <td  v-for="(wtc,index) in iteration1wetTrac" v-bind:key="index"  class="text-center">{{wtc.tractor_model}}</td>
                  </tr>
                  <tr>
                  <th class="text-left">Engine RPM set</th>
                  <td v-for="(wtc,index) in iteration1wetTrac" v-bind:key="index"  class="text-center" >{{wtc.engine_rpm_set}}</td>
                  </tr>
                  <tr>
                  <th class="text-left">PTO RPM set</th>
                  <td  v-for="(wtc,index) in iteration1wetTrac" v-bind:key="index"  class="text-center">{{wtc.pto_rpm_set}}</td>
                  </tr>
                  <tr>
                  <th class="text-left">Gear Used</th>
                  <td v-for="(wtc,index) in iteration1wetTrac" v-bind:key="index"  class="text-center">{{wtc.gear_used}}</td>
                  </tr>
                  <tr>
                  <th class="text-left">Nominal Speed (KMPH)</th>
                  <td v-for="(wtc,index) in iteration1wetTrac" v-bind:key="index" class="text-center">{{wtc.nominal_speed_kmph}}</td>
                  </tr>
                  <tr>
                  <th class="text-left">Engine RPM Drop on straight 1st Pass (KMPH)</th>
                  <td  v-for="(wtc,index) in iteration1wetTrac" v-bind:key="index"  class="text-center">{{wtc.engine_rpm_drop_on_straight_1st_pass}}</td>
                  </tr>
                  <tr>
                  <th class="text-left">Engine RPM Drop on straight 2nd Pass</th>
                  <td  v-for="(wtc,index) in iteration1wetTrac" v-bind:key="index" class="text-center">{{wtc.engine_rpm_drop_on_straight_2nd_pass}}</td>
                  </tr>
                  <tr>
                  <th class="text-left">Engine RPM Drop on straight 3rd Pass</th>
                  <td  v-for="(wtc,index) in iteration1wetTrac" v-bind:key="index"  class="text-center">{{wtc.engine_rpm_drop_on_straight_3rd_pass}}</td>
                  </tr>
                  <tr>
                  <th class="text-left">Engine RPM Drop on turn 1st Pass</th>
                  <td  v-for="(wtc,index) in iteration1wetTrac" v-bind:key="index"  class="text-center">{{wtc.engine_rpm_drop_on_turn_1st_pass}}</td>
                  </tr>
                  <tr>
                  <th class="text-left">Engine RPM Drop on turn 2nd Pass</th>
                  <td  v-for="(wtc,index) in iteration1wetTrac" v-bind:key="index" class="text-center">{{wtc.engine_rpm_drop_on_turn_2nd_pass}}</td>
                  </tr>
                  <tr>
                  <th class="text-left">Engine RPM Drop on turn 3rd Pass</th>
                  <td  v-for="(wtc,index) in iteration1wetTrac" v-bind:key="index"  class="text-center">{{wtc.engine_rpm_drop_on_turn_3rd_pass}}</td>
                  </tr>
                  <tr>
                  <th class="text-left">No. of passes</th>
                  <td v-for="(wtc,index) in iteration1wetTrac" v-bind:key="index"  class="text-center">{{wtc.no_of_passes}}</td>
                  </tr>
                  <tr>
                  <th class="text-left color4">Depth of cut (cm)</th>
                  <td  v-for="(wtc,index) in iteration1wetTrac" v-bind:key="index"  class="text-center color4">{{wtc.depth_of_cut_cm}}</td>
                  </tr>
                   <tr>
                   <th class="text-left color4">Fuel consumption (lit/hr)</th>
                   <td  v-for="(wtc,index) in iteration1wetTrac" v-bind:key="index"  class="text-center color4">{{wtc.fuel_consumption_lit_per_hr}}</td>
                   </tr>
                  <tr>
                  <th class="text-left color5">Area covered (acr/hr)</th>
                  <td  v-for="(wtc,index) in iteration1wetTrac" v-bind:key="index"  class="text-center color5">{{wtc.area_covered_acr_per_hr}}</td>
                  </tr>
                  <tr>
                  <th class="text-left color6">Fuel consumption (lit/Acr)</th>
                  <td v-for="(wtc,index) in iteration1wetTrac" v-bind:key="index" class="text-center color6">{{wtc.fuel_consumption_lit_per_acr}}</td>
                  </tr>
                  <tr>
                  <th colspan="6" class="text-left">Observations:</th>
                  </tr>
                  <tr>
                  <th colspan="6" class="md-list-item-text">{{this.iteration1wetTrac[0].observations}}</th>
                  </tr>
                  </template>
                  <template v-if="iteration2wetTrac.length > 0">
                    <tr>
                    <th class="text-left color3">Test Condition</th>
                    <th  class="text-center" colspan="6">{{iteration2wetTrac[0].test_condition}}</th>
                    </tr>
                    <tr >
                    <th class="text-left">Tractor Model</th>
                    <td  v-for="(wtc,index) in iteration2wetTrac" v-bind:key="index"  class="text-center">{{wtc.tractor_model}}</td>
                    </tr>
                    <tr>
                    <th class="text-left">Engine RPM set</th>
                    <td v-for="(wtc,index) in iteration2wetTrac" v-bind:key="index"  class="text-center" >{{wtc.engine_rpm_set}}</td>
                    </tr>
                    <tr>
                    <th class="text-left">PTO RPM set</th>
                    <td  v-for="(wtc,index) in iteration2wetTrac" v-bind:key="index"  class="text-center">{{wtc.pto_rpm_set}}</td>
                    </tr>
                    <tr>
                    <th class="text-left">Gear Used</th>
                    <td v-for="(wtc,index) in iteration2wetTrac" v-bind:key="index"  class="text-center">{{wtc.gear_used}}</td>
                    </tr>
                    <tr>
                    <th class="text-left">Nominal Speed (KMPH)</th>
                    <td v-for="(wtc,index) in iteration2wetTrac" v-bind:key="index" class="text-center">{{wtc.nominal_speed_kmph}}</td>
                    </tr>
                    <tr>
                    <th class="text-left">Engine RPM Drop on straight 1st Pass (KMPH)</th>
                    <td  v-for="(wtc,index) in iteration2wetTrac" v-bind:key="index"  class="text-center">{{wtc.engine_rpm_drop_on_straight_1st_pass}}</td>
                    </tr>
                    <tr>
                    <th class="text-left">Engine RPM Drop on straight 2nd Pass</th>
                    <td  v-for="(wtc,index) in iteration2wetTrac" v-bind:key="index" class="text-center">{{wtc.engine_rpm_drop_on_straight_2nd_pass}}</td>
                    </tr>
                    <tr>
                    <th class="text-left">Engine RPM Drop on straight 3rd Pass</th>
                    <td  v-for="(wtc,index) in iteration2wetTrac" v-bind:key="index"  class="text-center">{{wtc.engine_rpm_drop_on_straight_3rd_pass}}</td>
                    </tr>
                    <tr>
                    <th class="text-left">Engine RPM Drop on turn 1st Pass</th>
                    <td  v-for="(wtc,index) in iteration2wetTrac" v-bind:key="index"  class="text-center">{{wtc.engine_rpm_drop_on_turn_1st_pass}}</td>
                    </tr>
                    <tr>
                    <th class="text-left">Engine RPM Drop on turn 2nd Pass</th>
                    <td  v-for="(wtc,index) in iteration2wetTrac" v-bind:key="index" class="text-center">{{wtc.engine_rpm_drop_on_turn_2nd_pass}}</td>
                    </tr>
                    <tr>
                    <th class="text-left">Engine RPM Drop on turn 3rd Pass</th>
                    <td  v-for="(wtc,index) in iteration2wetTrac" v-bind:key="index"  class="text-center">{{wtc.engine_rpm_drop_on_turn_3rd_pass}}</td>
                    </tr>
                    <tr>
                    <th class="text-left">No. of passes</th>
                    <td v-for="(wtc,index) in iteration2wetTrac" v-bind:key="index"  class="text-center">{{wtc.no_of_passes}}</td>
                    </tr>
                    <tr>
                    <th class="text-left color4">Depth of cut (cm)</th>
                    <td  v-for="(wtc,index) in iteration2wetTrac" v-bind:key="index"  class="text-center color4">{{wtc.depth_of_cut_cm}}</td>
                    </tr>
                     <tr>
                     <th class="text-left color4">Fuel consumption (lit/hr)</th>
                     <td  v-for="(wtc,index) in iteration2wetTrac" v-bind:key="index"  class="text-center color4">{{wtc.fuel_consumption_lit_per_hr}}</td>
                     </tr>
                    <tr>
                    <th class="text-left color5">Area covered (acr/hr)</th>
                    <td  v-for="(wtc,index) in iteration2wetTrac" v-bind:key="index"  class="text-center color5">{{wtc.area_covered_acr_per_hr}}</td>
                    </tr>
                    <tr>
                    <th class="text-left color6">Fuel consumption (lit/Acr)</th>
                    <td v-for="(wtc,index) in iteration2wetTrac" v-bind:key="index" class="text-center color6">{{wtc.fuel_consumption_lit_per_acr}}</td>
                    </tr>
                    <tr>
                    <th colspan="6" class="text-left">Observations:</th>
                    </tr>
                    <tr>
                    <th colspan="6" class="md-list-item-text">{{this.iteration2wetTrac[0].observations}}</th>
                    </tr>
                    </template>
                    <template v-if="iteration3wetTrac.length > 0">
                      <tr>
                      <th class="text-left color3">Test Condition</th>
                      <th  class="text-center" colspan="6">{{iteration3wetTrac[0].test_condition}}</th>
                      </tr>
                      <tr >
                      <th class="text-left">Tractor Model</th>
                      <td  v-for="(wtc,index) in iteration3wetTrac" v-bind:key="index"  class="text-center">{{wtc.tractor_model}}</td>
                      </tr>
                      <tr>
                      <th class="text-left">Engine RPM set</th>
                      <td v-for="(wtc,index) in iteration3wetTrac" v-bind:key="index"  class="text-center" >{{wtc.engine_rpm_set}}</td>
                      </tr>
                      <tr>
                      <th class="text-left">PTO RPM set</th>
                      <td  v-for="(wtc,index) in iteration3wetTrac" v-bind:key="index"  class="text-center">{{wtc.pto_rpm_set}}</td>
                      </tr>
                      <tr>
                      <th class="text-left">Gear Used</th>
                      <td v-for="(wtc,index) in iteration3wetTrac" v-bind:key="index"  class="text-center">{{wtc.gear_used}}</td>
                      </tr>
                      <tr>
                      <th class="text-left">Nominal Speed (KMPH)</th>
                      <td v-for="(wtc,index) in iteration3wetTrac" v-bind:key="index" class="text-center">{{wtc.nominal_speed_kmph}}</td>
                      </tr>
                      <tr>
                      <th class="text-left">Engine RPM Drop on straight 1st Pass (KMPH)</th>
                      <td  v-for="(wtc,index) in iteration3wetTrac" v-bind:key="index"  class="text-center">{{wtc.engine_rpm_drop_on_straight_1st_pass}}</td>
                      </tr>
                      <tr>
                      <th class="text-left">Engine RPM Drop on straight 2nd Pass</th>
                      <td  v-for="(wtc,index) in iteration3wetTrac" v-bind:key="index" class="text-center">{{wtc.engine_rpm_drop_on_straight_2nd_pass}}</td>
                      </tr>
                      <tr>
                      <th class="text-left">Engine RPM Drop on straight 3rd Pass</th>
                      <td  v-for="(wtc,index) in iteration3wetTrac" v-bind:key="index"  class="text-center">{{wtc.engine_rpm_drop_on_straight_3rd_pass}}</td>
                      </tr>
                      <tr>
                      <th class="text-left">Engine RPM Drop on turn 1st Pass</th>
                      <td  v-for="(wtc,index) in iteration3wetTrac" v-bind:key="index"  class="text-center">{{wtc.engine_rpm_drop_on_turn_1st_pass}}</td>
                      </tr>
                      <tr>
                      <th class="text-left">Engine RPM Drop on turn 2nd Pass</th>
                      <td  v-for="(wtc,index) in iteration3wetTrac" v-bind:key="index" class="text-center">{{wtc.engine_rpm_drop_on_turn_2nd_pass}}</td>
                      </tr>
                      <tr>
                      <th class="text-left">Engine RPM Drop on turn 3rd Pass</th>
                      <td  v-for="(wtc,index) in iteration3wetTrac" v-bind:key="index"  class="text-center">{{wtc.engine_rpm_drop_on_turn_3rd_pass}}</td>
                      </tr>
                      <tr>
                      <th class="text-left">No. of passes</th>
                      <td v-for="(wtc,index) in iteration3wetTrac" v-bind:key="index"  class="text-center">{{wtc.no_of_passes}}</td>
                      </tr>
                      <tr>
                      <th class="text-left color4">Depth of cut (cm)</th>
                      <td  v-for="(wtc,index) in iteration3wetTrac" v-bind:key="index"  class="text-center color4">{{wtc.depth_of_cut_cm}}</td>
                      </tr>
                       <tr>
                       <th class="text-left color4">Fuel consumption (lit/hr)</th>
                       <td  v-for="(wtc,index) in iteration3wetTrac" v-bind:key="index"  class="text-center color4">{{wtc.fuel_consumption_lit_per_hr}}</td>
                       </tr>
                      <tr>
                      <th class="text-left color5">Area covered (acr/hr)</th>
                      <td  v-for="(wtc,index) in iteration3wetTrac" v-bind:key="index"  class="text-center color5">{{wtc.area_covered_acr_per_hr}}</td>
                      </tr>
                      <tr>
                      <th class="text-left color6">Fuel consumption (lit/Acr)</th>
                      <td v-for="(wtc,index) in iteration3wetTrac" v-bind:key="index" class="text-center color6">{{wtc.fuel_consumption_lit_per_acr}}</td>
                      </tr>
                      <tr>
                      <th colspan="6" class="text-left">Observations:</th>
                      </tr>
                      <tr>
                      <th colspan="6" class="md-list-item-text">{{this.iteration3wetTrac[0].observations}}</th>
                      </tr>
                      </template>
                      <template v-if="iteration4wetTrac.length > 0">
                        <tr>
                        <th class="text-left color3">Test Condition</th>
                        <th  class="text-center" colspan="6">{{iteration4wetTrac[0].test_condition}}</th>
                        </tr>
                        <tr >
                        <th class="text-left">Tractor Model</th>
                        <td  v-for="(wtc,index) in iteration4wetTrac" v-bind:key="index"  class="text-center">{{wtc.tractor_model}}</td>
                        </tr>
                        <tr>
                        <th class="text-left">Engine RPM set</th>
                        <td v-for="(wtc,index) in iteration4wetTrac" v-bind:key="index"  class="text-center" >{{wtc.engine_rpm_set}}</td>
                        </tr>
                        <tr>
                        <th class="text-left">PTO RPM set</th>
                        <td  v-for="(wtc,index) in iteration4wetTrac" v-bind:key="index"  class="text-center">{{wtc.pto_rpm_set}}</td>
                        </tr>
                        <tr>
                        <th class="text-left">Gear Used</th>
                        <td v-for="(wtc,index) in iteration4wetTrac" v-bind:key="index"  class="text-center">{{wtc.gear_used}}</td>
                        </tr>
                        <tr>
                        <th class="text-left">Nominal Speed (KMPH)</th>
                        <td v-for="(wtc,index) in iteration4wetTrac" v-bind:key="index" class="text-center">{{wtc.nominal_speed_kmph}}</td>
                        </tr>
                        <tr>
                        <th class="text-left">Engine RPM Drop on straight 1st Pass (KMPH)</th>
                        <td  v-for="(wtc,index) in iteration4wetTrac" v-bind:key="index"  class="text-center">{{wtc.engine_rpm_drop_on_straight_1st_pass}}</td>
                        </tr>
                        <tr>
                        <th class="text-left">Engine RPM Drop on straight 2nd Pass</th>
                        <td  v-for="(wtc,index) in iteration4wetTrac" v-bind:key="index" class="text-center">{{wtc.engine_rpm_drop_on_straight_2nd_pass}}</td>
                        </tr>
                        <tr>
                        <th class="text-left">Engine RPM Drop on straight 3rd Pass</th>
                        <td  v-for="(wtc,index) in iteration4wetTrac" v-bind:key="index"  class="text-center">{{wtc.engine_rpm_drop_on_straight_3rd_pass}}</td>
                        </tr>
                        <tr>
                        <th class="text-left">Engine RPM Drop on turn 1st Pass</th>
                        <td  v-for="(wtc,index) in iteration4wetTrac" v-bind:key="index"  class="text-center">{{wtc.engine_rpm_drop_on_turn_1st_pass}}</td>
                        </tr>
                        <tr>
                        <th class="text-left">Engine RPM Drop on turn 2nd Pass</th>
                        <td  v-for="(wtc,index) in iteration4wetTrac" v-bind:key="index" class="text-center">{{wtc.engine_rpm_drop_on_turn_2nd_pass}}</td>
                        </tr>
                        <tr>
                        <th class="text-left">Engine RPM Drop on turn 3rd Pass</th>
                        <td  v-for="(wtc,index) in iteration4wetTrac" v-bind:key="index"  class="text-center">{{wtc.engine_rpm_drop_on_turn_3rd_pass}}</td>
                        </tr>
                        <tr>
                        <th class="text-left">No. of passes</th>
                        <td v-for="(wtc,index) in iteration4wetTrac" v-bind:key="index"  class="text-center">{{wtc.no_of_passes}}</td>
                        </tr>
                        <tr>
                        <th class="text-left color4">Depth of cut (cm)</th>
                        <td  v-for="(wtc,index) in iteration4wetTrac" v-bind:key="index"  class="text-center color4">{{wtc.depth_of_cut_cm}}</td>
                        </tr>
                         <tr>
                         <th class="text-left color4">Fuel consumption (lit/hr)</th>
                         <td  v-for="(wtc,index) in iteration4wetTrac" v-bind:key="index"  class="text-center color4">{{wtc.fuel_consumption_lit_per_hr}}</td>
                         </tr>
                        <tr>
                        <th class="text-left color5">Area covered (acr/hr)</th>
                        <td  v-for="(wtc,index) in iteration4wetTrac" v-bind:key="index"  class="text-center color5">{{wtc.area_covered_acr_per_hr}}</td>
                        </tr>
                        <tr>
                        <th class="text-left color6">Fuel consumption (lit/Acr)</th>
                        <td v-for="(wtc,index) in iteration4wetTrac" v-bind:key="index" class="text-center color6">{{wtc.fuel_consumption_lit_per_acr}}</td>
                        </tr>
                        <tr>
                        <th colspan="6" class="text-left">Observations:</th>
                        </tr>
                        <tr>
                        <th colspan="6" class="md-list-item-text">{{this.iteration4wetTrac[0].observations}}</th>
                        </tr>
                        </template>
                  <tr class="text-center">
                  <th>Prepared by</th>
                  <td>{{this.footerdata[0].report_prepared_by}}</td>
                  <td> </td>
                  <td colspan="3"> </td>
                  </tr>
                  <tr class="text-center">
                  <th>Reviewed by</th>
                  <td>{{this.footerdata[0].report_reviewed_by}}</td>
                  <td> </td>
                  <td colspan="3"> </td>
                  </tr>
                  <tr class="text-center">
                  <th>Approved by</th>
                  <td >{{this.footerdata[0].report_approved_by}}</td>
                  <td> </td>
                  <td colspan="3"> </td>
                  </tr>
                  <tr>
                  <td> </td>
                  <th class="text-center">Name</th>
                  <th class="text-center">Signature</th>
                  <th class="text-center" colspan="4">Remarks, if any</th>
                  </tr>
                  <tr>
                  <th colspan="6" class="md-list-item-text" >THIS DOCUMENT SHOULD NOT BE REPRODUCED IN ANY FORM OR BY ANY MEANS WITHOUT  WRITTEN PERMISSION OF MAHINDRA & MAHINDRA LIMITED (FARM EQUIPMENT SECTOR)</th>
                  </tr>
                  <tr>
                  <th colspan="2" class="text-center" >Format No:{{this.footerdata[0].report_template_no}}</th>
                  <th colspan="2" class="text-center" >{{this.footerdata[0].report_template_rev_no}}</th>
                  <th colspan="2" class="text-center">{{this.footerdata[0].report_template_rev_date}}</th>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios'
import _ from 'lodash'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

export default {
  name: 'mmt-field-wet-report-screen',

  data: function() {
    return {
      output: [ ],
      repTitle:'',
      columns:[],
      keys: [ ],
      rowsdata: [ ],
      sortKey: [],
      sortOrder: ['asc'],
      dimSelectDpValues: [],
      rowsDataDimKeys: [],
      headerdata:[],
      wettrac:[],
      comptrac:[],
      footerdata:[],
      example:[],
      showtable:false,
      x:{},
      iteration1wetTrac:[],
      iteration2wetTrac:[],
      iteration3wetTrac:[],
      iteration4wetTrac:[],
      screenletListboxDim: ['tractor_make','platform','tractor_model','tractor_engine_hp','wheel_drive_type','configuration','location_name','name_of_implement','gear_used','engine_speed_var','test_date_year','test_file_name'],
      SLlistboxDimBizName:['Make','Platform','Model','HP','2WD/4WD','Configuration','Location','Application','Gear','Speed (rpm)','Year','File Name'],
      filterValue: '',
      // This is much simpler if the select is it's own component.
      selectVal: {
        isActive: undefined,
        age: undefined,
        first_name: undefined,
        last_name: undefined
      }
    }
  },
  created: function () {
   // this.loadReportConfig()
    this.fetchListboxData()
  //  this.listenToRouter()
  },
  computed: {
  getValues() {
        return (key1, x) => {
          // console.log("getValues ====> item", key1, x)
          var filteredData = this.example.filter((item) => {

            for (let kkk in x) { // loop over the keys of x
              //console.log("getValues >>>> ",kkk)

              if (x[kkk] && x[kkk].length > 0) { //check the value of each key is undefined/NULL or not
                //  console.log("getValues ,,,,",x[kkk],x[kkk].includes("All"))

                if (!x[kkk].includes('All')) { // check the value of the key doesn't contains All as a value
                  // console.log("getValues,,,,", item[kkk], x[kkk])
                  if (item[kkk] === undefined || !x[kkk].includes(item[kkk])) {

                    return false;
                  }
                }
              }
              //  console.log("not entered if")
            }
            return true;
          });

          var whereClause='1==1 '
          for (let kkk in x){
            // console.log("kkk x ",kkk, x,x[kkk],whereClause + ' && ! x[kkk]'+ '.includes("item["' + kkk + '"]) ')
            if (x[kkk] && x[kkk].length > 0 && x[key1] && x[key1].length>0) { //check the value of each key is undefined/NULL or not
              if(kkk ==key1){ // check if it is for the passed key then make it as not in
                whereClause = whereClause + ' && !x["'+kkk+'"]' + '.includes(item["' + kkk + '"]) '
              }
              else{ //if not append and clause
                whereClause = whereClause + ' && x["'+kkk+'"]' + '.includes(item["' + kkk + '"])'
              }

            }
            else if(x[key1] && x[key1].length<=0){
              whereClause = whereClause + " && 1==2 "
            }
          }
          var example1 = _.clone(this.example)

          var invertFilteredData = example1.filter((item) => {

            if(eval(whereClause) && item){
              return true;
            }
            else{
              return false
            }

          })
          var firstArray = _.uniq(filteredData.map(kv => kv[key1]))
          var secondArray = []
          if(x[key1] && x[key1].length>0){
            secondArray= _.uniq(invertFilteredData.map(kv => kv[key1]))
          }

          var unionArray = _.union(firstArray,secondArray)
          console.log("where clause",whereClause, x,key1,secondArray,invertFilteredData)
          return unionArray.sort(); //gets the unique values from the filteredData by mapping the passed key and sort the values in ascending order
        }

        //console.log("getValues -->",_.uniq(this.example.map(kv => kv[key])),k)
        //return _.uniq(this.example.map(kv => kv[key]))
        /*if(k) {
            console.log("getValues with k selected",_.uniq(this.example.filter(kv => kv[key] === k).map(kv => kv[key])))
            return _.uniq(this.example.filter(kv => kv[key] === k).map(kv => kv[key]))
        }
        else if(k=='All'){
            console.log("getValues with All selected",_.uniq(this.example.map(kv => kv[key])))
            return _.uniq(this.example.map(kv => kv[key]))
        }
        else {
            console.log("getValues with default",_.uniq(this.example.map(kv => kv[key])))
            return _.uniq(this.example.map(kv => kv[key]))
        }*/
      },
    "Rcolumns": function columns() {
      if (this.rowsdata.length == 0) {
        return [];
      }
      return Object.keys(this.rowsdata[0])
    },
    "orderedData": function () {
      let result=this.rowsdata;
      if (this.filterValue) {
        result = result.filter(item => item.rd2.includes(this.filterValue));
      }
      return _.orderBy(result, this.sortKey, this.sortOrder)
    },
    options() {
      // This could be simplified if the select was it's own component.
      const options = {};
      this.rowsDataDimKeys.forEach(key => {
        const vals = this.rowsdata.map(item => item[key]);
        console.log("Options Data Vals",vals);
        // Cheap and efficient unique.
        options[key] = Array.from(new Set(vals)).sort();
        console.log("Distinct Options Data ",options[key]);
      });

      return options;
    }
  },
  methods: {
   generatePDF:function(x) {
       window.html2canvas=html2canvas
       var doc=new jsPDF("p","pt","a2")
       doc.html(document.querySelector("#content"), {
       callback:function(pdf) {
           console.log("fileName:",x.test_file_name)
              pdf.save(`${x.test_file_name}.pdf`)
      }
      })
      },
       reset:function() {
          this.x={}
          this.showtable=false
          },
    sortBy: function(key) {
      console.log("The sort Key is ",key)
      if (key == this.sortKey) {
        this.sortOrder = (this.sortOrder == 'asc') ? 'desc' : 'asc';
        this.sortKey=key;
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
    },
    toggleButton:function (){
                        console.log("toggle button call")
                        var element = document.getElementById("button");
                        element.classList.remove("btn-success")
                        element.classList.add("btn-warning");
                    },
        fetchListboxData: function () {
          axios.get('/api/fetchListboxData/LSQL37').then(res => {
            //console.log("Loop increment value inside api",index);

            let resData = res.data
            this.example = resData
            //convert set of values into an array using array.from
            //this.optionValues[index] = Array.from(new Set(resData.map(c => c.dim1).filter(x => x != null)))
            let temp = Array.from(new Set(resData.map(c => c.dim1).filter(x => x != null)))
            console.log("Salesman data option values:", resData, temp)
            //return temp
          }, err => {
            console.log('Error in fetching record', err)
          })
        },
    //Get Request
    listenToRouter: function () {
      let $this = this
      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`)
        //console.log(`router moved to ${from.path} from ${to.path}, page viz = ${$this.rows.length}`)
        $this.rowsdata = []
        $this.headerColumns= []
        setTimeout(() => {
          $this.loadReportConfig()
        }, 300)

      })
    },
    loadReportConfig: function (x) {
      console.info('loading summary',x)
      if(document.getElementById("button")){
        var element = document.getElementById("button");
        element.classList.remove("btn-warning")
        element.classList.add("btn-success");

      }
      let y={}
      Object.entries(x).forEach(
              ([key, value]) => {
                console.log("key value",key, value)
                 if (key=="test_file_name") y[key]=[value]
              }
      );
      console.log("key value after conversion",y)
    //  let menuParam = this.$route.params.submenuId
      //  let submenuParam = this.$route.params.submenuId

      //Get Request
     axios.post('/api/fetchDataWithParam/SQL711/Any', y).then(res => {
              let data = res.data;
             this.headerdata =data.rowsData;

            console.log("Spec group data",this.headerdata,this.headerdata[0].test_report_no)

          }, err => {
            console.log('Error Fetching data', err)
          })

       axios.post('/api/fetchDataWithParam/SQL712/Any', y).then(res => {
                     let data2 = res.data;
                    this.comptrac =data2.rowsData;
                   console.log("Spec group data2",this.comptrac)

                 }, err => {
                   console.log('Error Fetching data', err)
                 })

              axios.post('/api/fetchDataWithParam/SQL713/Any', y).then(res => {
                  let data3 = res.data;
                 this.wettrac =data3.rowsData;

                console.log("Spec group data3",this.wettrac)

               this.iteration1wetTrac= this.wettrac.filter(wettractor => wettractor.test_iteration_number ==1)
                console.log( "Iteration1",this.iteration1wetTrac)
                this.iteration2wetTrac= this.wettrac.filter(wettractor => wettractor.test_iteration_number ==2);
                console.log( "Iteration2",this.iteration2dryTrac)
                this.iteration3wetTrac= this.wettrac.filter(wettractor => wettractor.test_iteration_number ==3)
                console.log( "Iteration3",this.iteration3wetTrac)
                this.iteration4wetTrac= this.wettrac.filter(wettractor => wettractor.test_iteration_number ==4);
                console.log( "Iteration4",this.iteration4wetTrac)
              }, err => {
                console.log('Error Fetching data', err)
              })

               axios.post('/api/fetchDataWithParam/SQL714/Any', y).then(res => {
                    let data4 = res.data;
                   this.footerdata =data4.rowsData;

                  console.log("Spec group data4",this.footerdata)
                this.showtable=true;
                }, err => {
                  console.log('Error Fetching data', err)
                })

    }
  }
}
</script>
<style scope>
.title {
  font-size: 22px;
}
th {
 font-size: 15px;
}
.grid-container {
  overflow-y: auto;
  height: 500px;
}
td  {
  text-align: center;
}
.md-list-item-text {
  white-space: normal;
  padding-bottom: 3rem;
}
</style>